import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { ActionButton } from '../../../components/ActionButton';
import { StyledActionButtonSmall } from '../../../components/ActionButton/styles';
import { Dropdown } from '../../../components/Dropdown';
import { StyledDropdownOption } from '../../../components/Dropdown/styles';
import { Tooltip } from '../../../components/Tooltip';

export const StyledActionButtonWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  margin: 0 0 16px;
`;

export const StyledActionButton = styled(ActionButton)`
  width: 100%;
  justify-content: center;
`;

export const StyledDropdown = styled(Dropdown)`
  padding: 4px;
  overflow: visible;
`;

export const StyledInfoButton = styled(StyledActionButtonSmall)`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`;

export const StyledInfoButtonWrapper = styled.div`
  margin-left: 6px;
`;

export const StyledExportDropdownOption = styled(StyledDropdownOption)`
  padding: 14px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledExportDropdownOptionTooltip = styled(Tooltip)`
  width: 100%;
`;

export const StyledCreditsLeftRow = styled.button`
  padding: 12px 16px;
  background-color: ${colorsPalettes.carbon[0]};
  ${setFontVariant('caption', colorsPalettes.carbon[400])};
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  &:hover {
    background-color: ${colorsPalettes.carbon[25]};
  }

  ${SWReactIcons} {
    flex-shrink: 0;

    svg path {
      fill: ${colorsPalettes.carbon[400]};
    }
  }

  > span {
    flex: 1;
    text-align: left;
  }
`;
